export const distanceOrTown = (item = {}, postCode = null) => {
  let distance;
  if (!item.dealer) {
    return 'N/A';
  }
  const dealer = item.dealer;

  if (item.distance || postCode) {
    distance = Math.round(item.distance);
    return `${distance} mile${distance > 1 ? 's' : ''} away`;
  }

  const city = dealer.city ? capitalize(dealer.city) : '';

  const county = dealer.county ? `, ${capitalize(dealer.county)}` : '';

  return `${city}${county}`;
};

const capitalize = str => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};



// WEBPACK FOOTER //
// ./src/Common/distanceOrTown/index.js